import { render, staticRenderFns } from "./AppSpeechModal.vue?vue&type=template&id=cec6a38c&scoped=true&"
import script from "./AppSpeechModal.vue?vue&type=script&lang=js&"
export * from "./AppSpeechModal.vue?vue&type=script&lang=js&"
import style0 from "./AppSpeechModal.vue?vue&type=style&index=0&id=cec6a38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec6a38c",
  null
  
)

export default component.exports